import React, { useState, useEffect } from 'react';

// Task : wil add animation like circle around the weather box and also add some more features like humidity, wind speed, pressure, etc.

function getWeatherIcon(wmoCode) {
	const icons = new Map([
		[[0], '☀️'],
		[[1], '🌤'],
		[[2], '⛅️'],
		[[3], '☁️'],
		[[45, 48], '🌫'],
		[[51, 56, 61, 66, 80], '🌦'],
		[[53, 55, 63, 65, 57, 67, 81, 82], '🌧'],
		[[71, 73, 75, 77, 85, 86], '🌨'],
		[[95], '🌩'],
		[[96, 99], '⛈'],
	]);
	const arr = [...icons.keys()].find((key) => key.includes(wmoCode));
	if (!arr) return 'NOT FOUND';
	return icons.get(arr);
}

function convertToFlag(countryCode) {
	console.log('Country Code:', countryCode);
	const codePoints = countryCode
		.toUpperCase()
		.split('')
		.map((char) => 127397 + char.charCodeAt());
	const flagEmoji = String.fromCodePoint(...codePoints);
	return flagEmoji;
}

function formatDay(dateStr) {
	return new Intl.DateTimeFormat('en', {
		weekday: 'short',
	}).format(new Date(dateStr));
}

function App() {
	const [location, setLocation] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [weatherData, setWeatherData] = useState({});
	const [displayLocation, setDisplayLocation] = useState('');

	const fetchWeather = async () => {
		if (location.length < 2) {
			setWeatherData({});
			return;
		}

		try {
			setIsLoading(true);
			// 1) Getting location (geocoding)
			const geoRes = await fetch(
				`https://geocoding-api.open-meteo.com/v1/search?name=${location}`,
			);
			const geoData = await geoRes.json();
			console.log(geoData);

			if (!geoData.results) throw new Error('Location not found');

			const { latitude, longitude, timezone, name, country_code } =
				geoData.results.at(0);
			setDisplayLocation(`${name} ${convertToFlag(country_code)}`);

			// 2) Getting actual weather
			const weatherRes = await fetch(
				`https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&timezone=${timezone}&daily=weathercode,temperature_2m_max,temperature_2m_min`,
			);
			const weatherData = await weatherRes.json();
			setWeatherData(weatherData.daily);
		} catch (err) {
			console.error(err);
		} finally {
			setIsLoading(false);
		}
	};

	const setLocationChange = (e) => setLocation(e.target.value);

	useEffect(() => {
		// setLocation(localStorage.getItem('location') || '');

		const savedLocation = localStorage.getItem('location');
		if (savedLocation) setLocation(savedLocation);
	}, []);

	useEffect(() => {
		// useEffect [location]
		if (location !== localStorage.getItem('location')) {
			fetchWeather();
			localStorage.setItem('location', location);
		}
	}, [location]);

	return (
		<div className='app'>
			<h1>Classy Weather</h1>

			<Input location={location} onInputChange={setLocationChange} />

			{isLoading ? <p className='loader'>Loading</p> : ''}

			{weatherData.weathercode && (
				<Weather weatherData={weatherData} displayLocation={displayLocation} />
			)}
		</div>
	);
}

function Input({ location, onInputChange }) {
	return (
		<div>
			<input
				type='text'
				placeholder='Search From Location...'
				value={location}
				onChange={onInputChange}
			/>
		</div>
	);
}

function Weather({ weatherData, displayLocation }) {
	useEffect(() => {
		// componentWillUnmount equivalent
		return () => {
			console.log('Weather suddenly disappeared');
		};
	}, []);

	const {
		temperature_2m_max: max,
		temperature_2m_min: min,
		time: dates,
		weathercode: codes,
	} = weatherData;

	return (
		<div>
			<h2>
				weather {displayLocation}
				<span role='img' aria-label='location'>
					📍
				</span>
			</h2>
			<ul className='weather'>
				{dates.map((date, i) => (
					<Day
						date={date}
						max={max.at(i)}
						min={min[i]}
						code={codes.at(i)}
						key={date}
						isToday={i === 0}
					/>
				))}
			</ul>
		</div>
	);
}

function Day({ date, max, min, code, isToday }) {
	return (
		<li className='day'>
			<span>{getWeatherIcon(code)}</span>
			<p>{isToday ? 'today' : formatDay(date)}</p>
			<p>
				{Math.floor(min)}&deg; &mdash;{' '}
				<strong> {Math.ceil(max)}&deg; &mdash;</strong>
			</p>
		</li>
	);
}

export default App;
